import { createClient } from "@sanity/client";

const projectId = (process.env.REACT_APP_SANITY_PROJECT_ID || "").trim();
const dataset = (process.env.REACT_APP_SANITY_DATASET || "production").trim();
const apiVersion = (process.env.REACT_APP_SANITY_API_VERSION || "2024-01-01").trim();

export function isSanityConfigured() {
  return Boolean(projectId);
}

export const sanityClient = isSanityConfigured()
  ? createClient({
      projectId,
      dataset,
      apiVersion,
      useCdn: true,
    })
  : null;

const postFields = `
  _id,
  title,
  "slug": slug.current,
  publishedAt,
  readMinutes,
  excerpt,
  mainImage{
    asset->{
      _id,
      url
    },
    alt
  }
`;

export async function fetchBlogPosts() {
  if (!sanityClient) return [];
  return sanityClient.fetch(
    `*[_type == "post" && defined(slug.current)] | order(publishedAt desc) {
      ${postFields}
    }`
  );
}

export async function fetchBlogPostBySlug(slug) {
  if (!sanityClient || !slug) return null;
  return sanityClient.fetch(
    `*[_type == "post" && slug.current == $slug][0] {
      ${postFields},
      body
    }`,
    { slug }
  );
}

export function formatBlogDate(dateString) {
  if (!dateString) return "";
  try {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return dateString;
  }
}
